import {isRejectedWithValue} from '@reduxjs/toolkit';
import {FetchBaseQueryError} from '@reduxjs/toolkit/query';

export function doesErrorMatch(
  error: FetchBaseQueryError,
  status: number,
  detail_code: string
): boolean {
  return (
    error.status === status && (error.data as any)?.detail_code === detail_code
  );
}

export function extractActionRequestError(
  action: any
): FetchBaseQueryError | undefined {
  if (
    isRejectedWithValue(action) &&
    action.payload?.status &&
    action.meta?.baseQueryMeta?.request
  ) {
    return action.payload as FetchBaseQueryError;
  }
}
